import React from 'react'

const AppStateContext = React.createContext()
const AppDispatchContext = React.createContext()

function appReducer(state, action) {
  switch (action.type) {
    case 'setLocations': {
      return {
        ...state,
        locations: action.payload,
      }
    }
    case 'setSelectedLocation': {
      return {
        ...state,
        selectedLocation: action.payload,
        mapVisible: true,
      }
    }
    case 'setSidebarOpen': {
      return {
        ...state,
        sidebarOpen: action.payload,
      }
    }
    case 'setMapVisible': {
      return {
        ...state,
        mapVisible: action.payload,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function AppProvider({ children }) {
  const [state, dispatch] = React.useReducer(appReducer, {
    locations: [],
    selectedLocation: null,
    sidebarOpen: true,
    mapVisible: window.matchMedia('(min-width: 768px)').matches,
  })

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

function useAppState() {
  const context = React.useContext(AppStateContext)

  if (context === undefined) {
    throw new Error('useAppState must be used within a AppProvider')
  }

  return context
}

function useAppDispatch() {
  const context = React.useContext(AppDispatchContext)

  if (context === undefined) {
    throw new Error('useAppDispatch must be used within a AppProvider')
  }

  return context
}

export { AppProvider, useAppState, useAppDispatch }
